<template>
  <div class="overflow-hidden pt-3">
    <b-row class="sidebar-header">
      <b-col class="d-flex justify-content-end">
        <a href="/user/news/list" target="_blank">
          <b-button @click.prevent="redirect2News()" size="sm" variant="info"
            ><i class="fas fa-stream" />
            {{ $t('actions.title.news') }}</b-button
          >
        </a>
      </b-col>
    </b-row>
    <b-overlay
      :show="isLoading"
      rounded
      opacity="0.6"
      spinner
      spinner-variant="primary"
    >
      <div class="mt-2 px-1">
        <ul class="history-wrapper" ref="news-list">
          <li
            v-for="(item, i) in news"
            :key="i"
            @click="toggleDetail(item.id)"
            class="item px-1 news-item"
          >
            <div class="news-row">
              <strong class="title">{{ getTitle(item) }}</strong>
              <span class="date">
                {{ item.created_at | formatDate }}
              </span>
            </div>
          </li>
        </ul>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import api from '../../api/stoTrade'
const icapitalUrl = ''

export default {
  name: 'NewsList',
  data() {
    return {
      isLoading: true,
      news: [],
      page: 1,
      HistoryLastPage: 1,
      detailView: -1,
    }
  },
  mounted() {
    this.page = 0
    const listElm = this.$refs['news-list']
    if (listElm) {
      listElm.addEventListener('scroll', () => {
        if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
          setTimeout(() => {
            this.page += 1
            if (this.page <= this.HistoryLastPage) this.fetchData()
          }, 400)
        }
      })
    }
    this.fetchData()
  },
  beforeDestroy() {
    this.$refs['news-list'].removeEventListener('scroll', () => {})
  },
  methods: {
    async fetchData() {
      this.isLoading = true
      try {
        const {
          data: { data, ...page },
        } = await api.getNews({ page: this.page })
        this.HistoryLastPage = page && page.last_page
        this.news = [...data]
      } catch (e) {
        console.error(e)
        this.news = []
      }
      this.isLoading = false
    },
    toggleDetail(id) {
      // this.$root.$emit('bv::toggle::collapse', `collapse-${id}`);
      window.open(icapitalUrl + 'news/' + id, '_blank')
    },
    openDetail(id) {
      this.detailView = id
    },
    getTitle(item) {
      return window._locale === 'mn' ? item.title : item.title_en
    },
    redirect2News() {
      window.open(icapitalUrl + '#icapital-news', '_blank')
    },
  },
}
</script>

<style lang="scss" src="../../../sass/partials/sidebar-submenu.scss"></style>
